package com.evoapps.evoshift.ui.finance

import androidx.compose.material3.AssistChipDefaults
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.ui.util.LocalDayWeather
import com.evoapps.evoshift.ui.util.LocalDaySpecials
import com.evoapps.evoshift.ui.util.SpecialDayMarker
import com.evoapps.evoshift.ui.util.SpecialDaysLine
import com.evoapps.evoshift.ui.util.WeatherAttribution
import com.evoapps.evoshift.ui.util.WeatherBadge
import com.evoapps.evoshift.domain.explain.Calculation
import com.evoapps.evoshift.domain.explain.Side
import androidx.compose.material.icons.outlined.Info
import androidx.compose.material.icons.filled.Close
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.theme.MotionVisibility
import com.evoapps.evoshift.ui.util.dayAndMonth
import com.evoapps.evoshift.widgets.ErrorState
import evoshift.composeapp.generated.resources.daily_records_enter_takings_for
import evoshift.composeapp.generated.resources.daily_records_notes_hide
import evoshift.composeapp.generated.resources.daily_records_notes_show
import evoshift.composeapp.generated.resources.daily_records_target_chip
import evoshift.composeapp.generated.resources.daily_records_target_header
import com.evoapps.evoshift.viewmodels.MissingPayScope
import com.evoapps.evoshift.widgets.CollapsingHeaderLayout
import com.evoapps.evoshift.domain.model.LabourBase
import com.evoapps.evoshift.ui.util.formatPercentOrDash
import com.evoapps.evoshift.ui.util.labourBase
import com.evoapps.evoshift.ui.util.labourPlanLabelRes
import com.evoapps.evoshift.ui.util.labourRealLabelRes
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.material3.LocalContentColor
import com.evoapps.evoshift.ui.util.LocalDayClosures
import com.evoapps.evoshift.ui.util.LocalStaffingHints
import com.evoapps.evoshift.ui.util.StaffingChip
import com.evoapps.evoshift.ui.util.StaffingHintLines
import com.evoapps.evoshift.domain.staffing.DayStaffingHint
import com.evoapps.evoshift.domain.usecase.finance.DaySuggestion
import com.evoapps.evoshift.ui.util.closureLabel
import evoshift.composeapp.generated.resources.day_closed
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.viewmodels.DEFAULT_CURRENCY
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.viewmodels.Gate
import evoshift.composeapp.generated.resources.number_invalid
import com.evoapps.evoshift.widgets.parseDecimal
import com.evoapps.evoshift.widgets.formatEditable
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.GoldButton
import com.evoapps.evoshift.widgets.StandoutCard
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.DialogAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.composed
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.semantics.clearAndSetSemantics
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.runtime.staticCompositionLocalOf
import kotlinx.coroutines.delay
import evoshift.composeapp.generated.resources.daily_records_preview_note
import androidx.compose.material.icons.filled.PointOfSale
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.showsDetailPane
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.ui.text.style.TextOverflow
import evoshift.composeapp.generated.resources.daily_records_hours_plan
import evoshift.composeapp.generated.resources.daily_records_hours_real
import evoshift.composeapp.generated.resources.cancel
import evoshift.composeapp.generated.resources.close
import evoshift.composeapp.generated.resources.daily_records_costs_plan
import evoshift.composeapp.generated.resources.daily_records_costs_real
import evoshift.composeapp.generated.resources.daily_records_locked
import evoshift.composeapp.generated.resources.daily_records_net_note
import evoshift.composeapp.generated.resources.daily_records_enter_results
import evoshift.composeapp.generated.resources.daily_records_prev_day
import evoshift.composeapp.generated.resources.daily_records_next_day
import evoshift.composeapp.generated.resources.daily_records_day_of
import evoshift.composeapp.generated.resources.daily_records_save_next
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowLeft
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.runtime.saveable.rememberSaveable
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import kotlinx.coroutines.launch
import evoshift.composeapp.generated.resources.daily_records_edit_target
import evoshift.composeapp.generated.resources.daily_records_labor_plan
import evoshift.composeapp.generated.resources.financials_estimate_note
import evoshift.composeapp.generated.resources.daily_records_labor_real
import evoshift.composeapp.generated.resources.daily_records_planned_labor
import evoshift.composeapp.generated.resources.daily_records_target_hint
import evoshift.composeapp.generated.resources.daily_records_target_title
import androidx.compose.material.icons.filled.Flag
import evoshift.composeapp.generated.resources.daily_records_result_plan
import evoshift.composeapp.generated.resources.daily_records_result_real
import evoshift.composeapp.generated.resources.daily_records_rev_plan
import evoshift.composeapp.generated.resources.daily_records_rev_real
import evoshift.composeapp.generated.resources.date
import com.evoapps.evoshift.ui.util.dayShort
import evoshift.composeapp.generated.resources.back
import evoshift.composeapp.generated.resources.daily_records_actual_net
import evoshift.composeapp.generated.resources.daily_records_comments
import evoshift.composeapp.generated.resources.daily_records_lock_confirm_text
import evoshift.composeapp.generated.resources.daily_records_lock_confirm_title
import evoshift.composeapp.generated.resources.daily_records_lock_no_takings
import evoshift.composeapp.generated.resources.daily_records_save_and_lock
import evoshift.composeapp.generated.resources.daily_records_unlock
import com.evoapps.evoshift.ui.util.dayAndDate
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import androidx.compose.material.icons.filled.LockOpen
import androidx.compose.material3.minimumInteractiveComponentSize
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import evoshift.composeapp.generated.resources.daily_records_lock
import evoshift.composeapp.generated.resources.daily_records_planned_net
import evoshift.composeapp.generated.resources.daily_records_title
import evoshift.composeapp.generated.resources.save
import org.jetbrains.compose.resources.stringResource
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.spmh_plan
import evoshift.composeapp.generated.resources.spmh_real
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import com.evoapps.evoshift.ui.adaptive.ListVerticalScrollbar
import com.evoapps.evoshift.ui.adaptive.RowHorizontalScrollbar
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.border
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.platform.testTag
import com.evoapps.evoshift.ui.LightMetallicBrush
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.text.rememberTextMeasurer
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.Constraints
import androidx.compose.ui.platform.LocalDensity
import com.evoapps.evoshift.domain.model.DailyRecord
import com.evoapps.evoshift.domain.model.DayResults
import com.evoapps.evoshift.viewmodels.DailyRecordsEvent
import com.evoapps.evoshift.viewmodels.DailyRecordsViewModel
import kotlinx.datetime.LocalDate
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.SnackbarHost
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.LaunchedEffect
import com.evoapps.evoshift.domain.model.Shift
import com.evoapps.evoshift.domain.usecase.shift.hasActualTime
import com.evoapps.evoshift.viewmodels.CopyPlanConfirmation
import evoshift.composeapp.generated.resources.copy_plan_confirm_text
import evoshift.composeapp.generated.resources.copy_plan_confirm_title
import evoshift.composeapp.generated.resources.copy_plan_day
import evoshift.composeapp.generated.resources.copy_plan_only_empty
import evoshift.composeapp.generated.resources.copy_plan_overwrite
import evoshift.composeapp.generated.resources.copy_plan_shift
import evoshift.composeapp.generated.resources.copy_plan_shift_description
import evoshift.composeapp.generated.resources.day_no_shifts
import evoshift.composeapp.generated.resources.day_shifts_title
import evoshift.composeapp.generated.resources.daily_records_income_plan
import evoshift.composeapp.generated.resources.daily_records_income_real
import evoshift.composeapp.generated.resources.shift_not_clocked
import evoshift.composeapp.generated.resources.shift_times_actual
import evoshift.composeapp.generated.resources.shift_times_planned



@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun DailyRecordsScreen(
    viewModel: DailyRecordsViewModel,
    onNavigateBack: () -> Unit,
    /** SH-257: the day's hours are confirmed in Godziny pracy, opened on that day (null: not offered). */
    onOpenWorkHours: ((date: String) -> Unit)? = null,
    /** SH-170: the takings entry opens at once on this day ("YYYY-MM-DD"; null: the list). */
    entryDate: String? = null
) {
    val uiState by viewModel.uiState.collectAsState()
    // SH-257: back from Godziny pracy, the day's hours are read again.
    LaunchedEffect(Unit) { viewModel.onEvent(DailyRecordsEvent.RefreshShifts) }
    var editingRecord by remember { mutableStateOf<DailyRecord?>(null) }
    var editingTarget by remember { mutableStateOf<DailyRecord?>(null) }
    // SH-228: a read-only role (or an ended plan) still opens a phone row's day, to read it.
    var viewingRecord by remember { mutableStateOf<DailyRecord?>(null) }
    // SH-71: entering the results day by day (a carousel of day cards) instead of the month.
    var entering by rememberSaveable { mutableStateOf(entryDate != null) }
    // SH-105: wide windows open a day in a pane beside the table (by ISO date), not a dialog.
    var selectedDay by rememberSaveable { mutableStateOf<String?>(null) }
    val wide = LocalWindowWidthClass.current.showsDetailPane
    val currency = uiState.workplace?.settings?.currency?.takeIf { it.isNotBlank() } ?: DEFAULT_CURRENCY
    // SH-46: what a copy of the planned times did.
    val snackbarHostState = remember { SnackbarHostState() }
    val message = uiState.message?.asString()
    LaunchedEffect(message) {
        message?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.onEvent(DailyRecordsEvent.MessageShown)
        }
    }

    val compact = LocalWindowWidthClass.current.isCompact
    val mayEnter = !entering && uiState.records.isNotEmpty() && uiState.capabilities.shows(Gate.MONEY_EDITING)
    // SH-168: on a phone the main action is a labelled button at the bottom ("Enter takings for
    // 3 February": the first day still without them), not a bare icon in the bar.
    val entryDay = uiState.entryStartDate?.let { runCatching { LocalDate.parse(it) }.getOrNull() }
    val showEntryButton = mayEnter && compact && entryDay != null && uiState.loadError == null

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        floatingActionButton = {
            // Kept while it folds away (the carousel opening), with the day it was showing.
            val lastEntryDay = remember { arrayOf<LocalDate?>(null) }
            if (entryDay != null) lastEntryDay[0] = entryDay
            val buttonDay = lastEntryDay[0]
            MotionVisibility(showEntryButton && buttonDay != null) {
                if (buttonDay == null) return@MotionVisibility
                ExtendedFloatingActionButton(
                    onClick = { entering = true },
                    icon = { Icon(Icons.Default.PointOfSale, contentDescription = null) },
                    text = { Text(stringResource(Res.string.daily_records_enter_takings_for, dayAndMonth(buttonDay)), fontWeight = FontWeight.Bold) },
                    containerColor = LightGold,
                    contentColor = DeepNavy,
                    modifier = Modifier.handCursor().testTag(DAILY_ENTRY_BUTTON_TAG)
                )
            }
        },
        topBar = {
            // SH-89: the shared bar: the workplace and the month (the app-wide one: App.kt opens
            // that month's records); the title stays, small, above the workplace.
            val enterLabel = stringResource(Res.string.daily_records_enter_results)
            val notesLabel = stringResource(Res.string.daily_records_notes_show)
            EvoTopBar(
                title = stringResource(if (entering) Res.string.daily_records_enter_results else Res.string.daily_records_title),
                // In the carousel, back returns to the month.
                onBack = { if (entering) entering = false else onNavigateBack() },
                showWorkplace = true,
                showMonth = true,
                actions = buildList {
                    // SH-168: the notes about the amounts, folded behind "i" after the first visit.
                    if (!entering && uiState.loadError == null) {
                        add(TopBarAction(
                            notesLabel, Icons.Outlined.Info,
                            { viewModel.onEvent(DailyRecordsEvent.SetNotesFolded(!uiState.notesFolded)) },
                            collapsible = false, testTag = DAILY_NOTES_BUTTON_TAG
                        ))
                    }
                    add(helpAction(HelpPage.DAILY_RECORDS))
                    if (mayEnter && !compact) {
                        add(TopBarAction(enterLabel, Icons.Default.PointOfSale, { entering = true }, prominent = true, iconOnCompact = true))
                    }
                }
            )
        }
    ) { padding ->
        // SH-253: provided around the whole content, the day dialogs included: the phone's day sheet
        // (EditActualsDialog) sat outside them and explained every person as "someone", a saved
        // day by contract type only (no fresh day) and its result without the recurring costs.
        // SH-55: the days the Sunday policy closes, read by the cards, rows and carousel.
        // SH-54: each day's staffing hint (money: only those who see it have any).
        // SH-128: weekends and public holidays, tinted in the table and on the day cards.
        // SH-195: kept while the month's ledger is the same (a new state is not a new rule).
        val ledger = uiState.ledger
        val resultDay = remember(ledger) { { record: DailyRecord -> DayResults.resultDay(record, ledger) } }
        CompositionLocalProvider(
            LocalDayClosures provides uiState.closedDays,
            LocalStaffingHints provides uiState.staffingHints,
            // SH-152: the figures' explanations: the team's names and each day worked out now.
            LocalExplainNames provides uiState.names,
            LocalFreshDay provides viewModel::freshDay,
            // SH-195: the daily results count each day's share of the month's recurring costs.
            LocalResultDay provides resultDay,
            LocalRestDays provides uiState.restDays,
            // SH-226: each day's weather (none with weather off).
            LocalDayWeather provides uiState.weather,
            // SH-227: each day's events and special days.
            LocalDaySpecials provides uiState.specialDays
        ) {
        val loadError = uiState.loadError
        if (loadError != null && uiState.records.isEmpty()) {
            // SH-168: the month could not be read: say so and offer Try again (not an empty month).
            ErrorState(loadError, onRetry = { viewModel.onEvent(DailyRecordsEvent.Retry) }, modifier = Modifier.padding(padding))
        } else if (uiState.isLoading && uiState.records.isEmpty()) {
            // SH-247: the month's days (cards on phones, the table on wider windows) until they are read.
            DailyRecordsPlaceholder(Modifier.padding(padding))
        } else {
            Column(Modifier.fillMaxSize().padding(padding)) {
                val records = uiState.records.values.toList()
                // Read-only once the plan ended (SH-65): the days to see, not to edit.
                val mayEdit = uiState.capabilities.shows(Gate.MONEY_EDITING)
                // SH-120: suggested targets from the sales history (none without enough of it).
                val pendingSuggestions = uiState.pendingSuggestions.size
                // SH-154: the notes slide away while the table scrolls (a phone held sideways has little height).
                CollapsingHeaderLayout(header = {
                    Column {
                        uiState.error?.let {
                            Text(it.asString(), color = MaterialTheme.colorScheme.error, modifier = Modifier.padding(16.dp))
                        }
                        // SH-168: open on the first visit, then folded behind the bar's "i".
                        DailyNotes(
                            folded = uiState.notesFolded || entering,
                            onFold = { viewModel.onEvent(DailyRecordsEvent.SetNotesFolded(true)) }
                        )
                        // SH-147: people working without pay terms leave the labour cost and % understated.
                        uiState.roster?.id?.let { rosterId ->
                            MissingPayBanner(MissingPayScope(rosterId), Modifier.padding(start = 16.dp, end = 16.dp, bottom = 8.dp))
                        }
                        // SH-226: the credit the weather's sources ask for, wherever it is shown.
                        if (!entering && uiState.weather.isNotEmpty()) {
                            WeatherAttribution(
                                uiState.weatherSources,
                                Modifier.padding(start = 16.dp, end = 16.dp, bottom = 8.dp)
                            )
                        }
                        if (mayEdit && !entering && pendingSuggestions > 0) {
                            ForecastBanner(
                                days = pendingSuggestions,
                                onUseAll = { viewModel.onEvent(DailyRecordsEvent.AcceptSuggestedTargets) },
                                modifier = Modifier.padding(start = 16.dp, end = 16.dp, bottom = 8.dp)
                            )
                        }
                    }
                }) {
                when {
                    entering && mayEdit -> DailyResultsCarousel(
                        records = records,
                        startDate = entryDate?.takeIf { it in uiState.records } ?: uiState.entryStartDate,
                        currency = currency,
                        onSave = { date, netto -> viewModel.onEvent(DailyRecordsEvent.SubmitTakings(date, netto)) },
                        onEditTarget = { editingTarget = it },
                        previews = uiState.previews,
                        staffingOf = uiState::staffingHintOf,
                        onPreview = { date, netto -> viewModel.onEvent(DailyRecordsEvent.Preview(date, netto)) },
                        onClearPreview = { date -> viewModel.onEvent(DailyRecordsEvent.ClearPreview(date)) }
                    )
                    // SH-105: figures, chart and table side by side, the chosen day in a pane.
                    wide -> DailyRecordsWideLayout(
                        records = records,
                        currency = currency,
                        selected = selectedDay?.let { uiState.records[it] },
                        onClose = { selectedDay = null },
                        table = {
                            DailyRecordsTable(
                                records = records,
                                currency = currency,
                                onRecordClick = { selectedDay = it.date },
                                onEditTarget = { if (mayEdit) editingTarget = it }
                            )
                        },
                        dayPane = { record ->
                            DailyRecordDayPane(
                                record = record,
                                currency = currency,
                                mayEdit = mayEdit,
                                onClose = { selectedDay = null },
                                staffing = uiState.staffingHintOf(record.date),
                                // SH-257: the day's hours in one line, confirmed in Godziny pracy.
                                hours = uiState.hoursSummary(record.date),
                                onOpenHours = onOpenWorkHours?.let { open -> { open(record.date) } },
                                preview = uiState.previews[record.date],
                                onPreview = { netto, plan -> viewModel.onEvent(DailyRecordsEvent.Preview(record.date, netto, plan)) },
                                onClearPreview = { viewModel.onEvent(DailyRecordsEvent.ClearPreview(record.date)) },
                                onSave = { netto, plan, comments ->
                                    viewModel.onEvent(DailyRecordsEvent.UpdateActuals(date = record.date, netto = netto, plan = plan, comments = comments))
                                },
                                onLock = { netto, plan, comments ->
                                    viewModel.onEvent(DailyRecordsEvent.SaveAndLockDay(date = record.date, netto = netto, plan = plan, comments = comments))
                                },
                                onUnlock = { viewModel.onEvent(DailyRecordsEvent.UnlockDay(record.date)) }
                            )
                        }
                    )
                    // SH-74: a phone in portrait gets a list of days instead of the wide table; SH-228:
                    // one compact row per day under the month so far, a tap opens the day's sheet.
                    LocalWindowWidthClass.current.isCompact -> DailyRecordsDayList(
                        records = records,
                        currency = currency,
                        // SH-168: the last row scrolls clear of the "Enter takings" button.
                        bottomPadding = if (showEntryButton) 88.dp else 8.dp,
                        onRecordClick = { if (mayEdit) editingRecord = it else viewingRecord = it }
                    )
                    else -> DailyRecordsTable(
                        records = records,
                        currency = currency,
                        onRecordClick = { if (mayEdit) editingRecord = it },
                        onEditTarget = { if (mayEdit) editingTarget = it }
                    )
                }
                }
            }
        }

        editingTarget?.let { record ->
            EditTargetDialog(
                record = record,
                currency = currency,
                suggestion = uiState.suggestions[record.date],
                onDismiss = { editingTarget = null },
                onSave = { target ->
                    viewModel.onEvent(DailyRecordsEvent.UpdateTarget(record.date, target))
                    editingTarget = null
                }
            )
        }

        editingRecord?.let { opened ->
            // The day as it is now (a copy of planned times changes its labour), its shifts live.
            val record = uiState.records[opened.date] ?: opened
            EditActualsDialog(
                record = record,
                onDismiss = { editingRecord = null },
                currency = currency,
                staffing = uiState.staffingHintOf(record.date),
                // SH-257: the day's hours in one line, confirmed in Godziny pracy.
                hours = uiState.hoursSummary(record.date),
                onOpenHours = onOpenWorkHours?.let { open ->
                    {
                        editingRecord = null
                        open(record.date)
                    }
                },
                preview = uiState.previews[record.date],
                onPreview = { netto, plan -> viewModel.onEvent(DailyRecordsEvent.Preview(record.date, netto, plan)) },
                onClearPreview = { viewModel.onEvent(DailyRecordsEvent.ClearPreview(record.date)) },
                // SH-228: the day's sales target from its sheet (the phone's rows have no flag).
                onEditTarget = {
                    editingRecord = null
                    editingTarget = record
                },
                onSave = { netto, plan, comments ->
                    viewModel.onEvent(
                        DailyRecordsEvent.UpdateActuals(
                            date = record.date,
                            netto = netto,
                            plan = plan,
                            comments = comments
                        )
                    )
                    editingRecord = null
                },
                onLock = { netto, plan, comments ->
                    viewModel.onEvent(DailyRecordsEvent.SaveAndLockDay(date = record.date, netto = netto, plan = plan, comments = comments))
                    editingRecord = null
                },
                // SH-163: whoever may lock a day may open it again (the dialog stays, now editable).
                onUnlock = { viewModel.onEvent(DailyRecordsEvent.UnlockDay(record.date)) }
            )
        }

        viewingRecord?.let { opened ->
            // SH-228: the day to read only (the sheet with its fields disabled).
            val record = uiState.records[opened.date] ?: opened
            EditActualsDialog(
                record = record,
                currency = currency,
                onDismiss = { viewingRecord = null },
                onSave = { _, _, _ -> },
                onLock = { _, _, _ -> },
                readOnly = true,
                staffing = uiState.staffingHintOf(record.date)
            )
        }

        uiState.copyConfirmation?.let { pending ->
            CopyPlanConfirmDialog(pending, onAnswer = { viewModel.onEvent(DailyRecordsEvent.ResolveCopy(it)) })
        }
        }
    }
}

/**
 * SH-168: every amount is net and the commission is counted from it (SH-70); labour cost and
 * labour % are planning estimates, not the pay run (SH-56). Open on the first visit; "Hide" (or
 * the bar's "i") folds them, and the device remembers it.
 */
@Composable
private fun DailyNotes(folded: Boolean, onFold: () -> Unit) {
    MotionVisibility(!folded) {
        // The fold button beside the notes, not under them: no extra line of height.
        Row(Modifier.fillMaxWidth().testTag(DAILY_NOTES_TAG).padding(start = 16.dp, top = 4.dp), verticalAlignment = Alignment.Top) {
            Icon(
                Icons.Outlined.Info, contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.padding(top = 6.dp, end = 8.dp).size(16.dp)
            )
            Column(Modifier.weight(1f).padding(top = 4.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                Text(
                    stringResource(Res.string.daily_records_net_note),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
                Text(
                    stringResource(Res.string.financials_estimate_note),
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
            }
            IconButtonWithTooltip(onClick = onFold, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.daily_records_notes_hide)) {
                Icon(
                    Icons.Default.Close,
                    contentDescription = stringResource(Res.string.daily_records_notes_hide),
                    tint = MaterialTheme.colorScheme.onSurfaceVariant,
                    modifier = Modifier.size(18.dp)
                )
            }
        }
    }
}

/**
 * SH-46: some of the shifts already have clocked times. Overwrite them with the planned ones, copy
 * only to the shifts without times (when there are any), or cancel.
 */
@Composable
fun CopyPlanConfirmDialog(pending: CopyPlanConfirmation, onAnswer: (overwrite: Boolean?) -> Unit) {
    EvoDialog(
        title = stringResource(Res.string.copy_plan_confirm_title),
        icon = Icons.Default.ContentCopy,
        onDismiss = { onAnswer(null) },
        confirm = DialogAction(stringResource(Res.string.copy_plan_overwrite), { onAnswer(true) }, destructive = true),
        neutral = if (pending.empty > 0) DialogAction(stringResource(Res.string.copy_plan_only_empty), { onAnswer(false) }) else null,
        dismiss = DialogAction(stringResource(Res.string.cancel), { onAnswer(null) })
    ) {
        Text(stringResource(Res.string.copy_plan_confirm_text, pending.clocked), style = MaterialTheme.typography.bodyMedium)
    }
}

/** Two labelled figures side by side (plan | actual) on a day card. */
@Composable
internal fun CardFigures(
    first: Pair<String, String>,
    second: Pair<String, String>,
    highlightSecond: Boolean = false,
    resultColor: Color? = null,
    labelColor: Color = MaterialTheme.colorScheme.onSurfaceVariant,
    highlightColor: Color = MaterialTheme.colorScheme.primary,
    /** SH-128: figures recalculated from typed values, not saved yet: in italics. */
    preview: Boolean = false,
    /** SH-152: how each figure was calculated (tap to see); null where there is nothing to explain. */
    firstWhy: (() -> Calculation?)? = null,
    secondWhy: (() -> Calculation?)? = null,
    currency: String = ""
) {
    Row(Modifier.fillMaxWidth().padding(top = 6.dp, end = 8.dp), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
        listOf(first, second).forEachIndexed { index, (label, value) ->
            Column(Modifier.weight(1f)) {
                Text(label, style = MaterialTheme.typography.labelSmall, color = labelColor, maxLines = 1, overflow = TextOverflow.Ellipsis)
                ExplainableAmount(
                    value,
                    explain = (if (index == 0) firstWhy else secondWhy).takeIf { value != "-" },
                    currency = currency,
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = if (resultColor != null || (index == 1 && highlightSecond)) FontWeight.Bold else FontWeight.Normal,
                    fontStyle = if (preview) FontStyle.Italic else FontStyle.Normal,
                    color = when {
                        index == 1 && resultColor != null -> resultColor
                        index == 1 && highlightSecond -> highlightColor
                        else -> Color.Unspecified
                    }
                )
            }
        }
    }
}

/**
 * SH-71: the month's results entered day by day: one card per day (date, planned target, the
 * takings input, the day's labour % plan and actual), swiped or moved with the arrows. It opens
 * on [startDate] (the first day still without takings); "Save and next" saves and moves on.
 */
@Composable
fun DailyResultsCarousel(
    records: List<DailyRecord>,
    startDate: String?,
    currency: String,
    onSave: (date: String, netto: Double) -> Unit,
    onEditTarget: (DailyRecord) -> Unit,
    /** SH-128: days recalculated from typed takings, by ISO date, until saved. */
    previews: Map<String, DailyRecord> = emptyMap(),
    staffingOf: (String) -> DayStaffingHint? = { null },
    onPreview: (date: String, netto: Double?) -> Unit = { _, _ -> },
    onClearPreview: (date: String) -> Unit = {}
) {
    if (records.isEmpty()) return
    val start = records.indexOfFirst { it.date == startDate }.coerceAtLeast(0)
    val pager = rememberPagerState(initialPage = start) { records.size }
    val scope = rememberCoroutineScope()
    fun go(page: Int) {
        scope.launch { pager.animateScrollToPage(page.coerceIn(0, records.size - 1)) }
    }

    Column(Modifier.fillMaxSize().contentWidth(ContentMaxWidth)) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(horizontal = 8.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            IconButtonWithTooltip(onClick = { go(pager.currentPage - 1) }, enabled = pager.currentPage > 0, tooltip = stringResource(Res.string.daily_records_prev_day)) {
                Icon(Icons.AutoMirrored.Filled.KeyboardArrowLeft, contentDescription = stringResource(Res.string.daily_records_prev_day))
            }
            Text(
                stringResource(Res.string.daily_records_day_of, pager.currentPage + 1, records.size),
                style = MaterialTheme.typography.labelLarge,
                textAlign = TextAlign.Center,
                modifier = Modifier.weight(1f)
            )
            IconButtonWithTooltip(onClick = { go(pager.currentPage + 1) }, enabled = pager.currentPage < records.size - 1, tooltip = stringResource(Res.string.daily_records_next_day)) {
                Icon(Icons.AutoMirrored.Filled.KeyboardArrowRight, contentDescription = stringResource(Res.string.daily_records_next_day))
            }
        }
        HorizontalPager(
            state = pager,
            // One whole card per page: neighbours are not peeking (nor composed), so the field and
            // the button on screen are the day shown.
            modifier = Modifier.fillMaxSize(),
            // Right under "Day X of Y", not centred in the page with empty bands around it.
            verticalAlignment = Alignment.Top,
            pageSpacing = 12.dp,
            key = { records[it].date }
        ) { page ->
            val record = records[page]
            DayResultCard(
                record = record,
                currency = currency,
                onSave = { netto ->
                    onSave(record.date, netto)
                    go(page + 1)
                },
                onEditTarget = { onEditTarget(record) },
                preview = previews[record.date],
                staffing = staffingOf(record.date),
                onPreview = { netto -> onPreview(record.date, netto) },
                onClearPreview = { onClearPreview(record.date) }
            )
        }
    }
}

@Composable
private fun DayResultCard(
    record: DailyRecord,
    currency: String,
    onSave: (Double) -> Unit,
    onEditTarget: () -> Unit,
    preview: DailyRecord? = null,
    staffing: DayStaffingHint? = null,
    onPreview: (Double?) -> Unit = {},
    onClearPreview: () -> Unit = {}
) {
    // Typed takings belong to the day; a saved figure coming back resets the field to it.
    var takings by remember(record.date, record.revenue.realNetto) {
        mutableStateOf(record.revenue.realNetto?.let { formatEditable(it) } ?: "")
    }
    val parsed = parseDecimal(takings)
    val invalid = takings.isNotBlank() && (parsed == null || parsed < 0)
    val date = LocalDate.parse(record.date)
    // SH-128: the labour % and the staffing hint follow the typed takings (a preview until saved).
    val previewNow = rememberTypedPreview(record.date, takings, enabled = !record.isLocked && !invalid, onClear = onClearPreview) {
        onPreview(parsed)
    }
    val shown = preview ?: record
    val isPreview = preview != null
    val hasActuals = shown.revenue.realNetto != null
    val why = rememberDayWhy(shown)

    // The navy-and-gold metallic card of the brand screens; its field and gold button are the
    // navy styles they were made for.
    val muted = Color.White.copy(alpha = 0.7f)
    StandoutCard(modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 8.dp)) {
        Column(Modifier.padding(18.dp).verticalScroll(rememberScrollState()), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Column(Modifier.weight(1f)) {
                    Text(dayLabel(record), style = MaterialTheme.typography.headlineSmall, fontWeight = FontWeight.Bold, color = LightGold)
                    Text(dayAndDate(date), style = MaterialTheme.typography.bodySmall, color = muted)
                    ClosedDayNote(record.date, color = Color.White)
                    staffing?.let { StaffingHintLines(it, currency, color = muted, onDark = true, modifier = Modifier.padding(top = 4.dp)) }
                }
                if (record.isLocked) {
                    Icon(Icons.Default.Lock, contentDescription = null, tint = muted)
                }
            }
            Row(verticalAlignment = Alignment.CenterVertically) {
                Column(Modifier.weight(1f)) {
                    Text(stringResource(Res.string.daily_records_planned_net), style = MaterialTheme.typography.labelMedium, color = muted)
                    Text(formatMoney(record.revenue.planNetto, currency), style = MaterialTheme.typography.titleMedium, color = Color.White)
                }
                EditTargetButton(record, onEditTarget, tint = LightGold)
            }
            if (record.isLocked) {
                Text(stringResource(Res.string.daily_records_locked), style = MaterialTheme.typography.bodyMedium, color = muted)
            }
            EvoTextField(
                value = takings,
                onValueChange = { takings = it },
                label = stringResource(Res.string.daily_records_actual_net),
                modifier = Modifier.previewOnBlur(previewNow),
                keyboardType = KeyboardType.Decimal,
                imeAction = ImeAction.Done,
                keyboardActions = KeyboardActions(onDone = {
                    previewNow()
                    defaultKeyboardAction(ImeAction.Done)
                }),
                error = stringResource(Res.string.number_invalid).takeIf { invalid },
                enabled = !record.isLocked,
                suffix = currency
            )
            CardFigures(
                stringResource(labourPlanLabelRes(shown.labourBase)) to formatPercentOrDash(shown.labourPercentPlan),
                stringResource(labourRealLabelRes(shown.labourBase)) to (if (hasActuals) formatPercentOrDash(shown.labourPercentReal) else "-"),
                firstWhy = why.labourPercent(Side.PLAN), secondWhy = why.labourPercent(Side.ACTUAL), currency = currency,
                highlightSecond = hasActuals,
                labelColor = muted,
                highlightColor = LightGold,
                preview = isPreview
            )
            // SH-95: with a commission, the share of the sales too, for comparison.
            if (shown.labourBase == LabourBase.INCOME) {
                CardFigures(
                    stringResource(Res.string.daily_records_labor_plan) to formatPercentOrDash(shown.labourPercentOfSalesPlan),
                    stringResource(Res.string.daily_records_labor_real) to (if (hasActuals) formatPercentOrDash(shown.labourPercentOfSalesReal) else "-"),
                    firstWhy = why.labourPercentOfSales(Side.PLAN), secondWhy = why.labourPercentOfSales(Side.ACTUAL), currency = currency,
                    labelColor = muted,
                    highlightColor = LightGold,
                    preview = isPreview
                )
            }
            // SH-191: SPMH next to the labour %, following the typed takings too.
            DaySpmhFigures(shown, currency, labelColor = muted, highlightColor = LightGold, highlightSecond = true, preview = isPreview)
            // SH-195: the day's result and margin, following the typed takings too.
            DayResultFigures(shown, currency, labelColor = muted, highlightColor = LightGold, onDark = true, preview = isPreview)
            // Its room is kept while there is no preview: the card must not change height under
            // the focused field (in the pager that scrolled to another day).
            PreviewNote(muted, visible = isPreview)
            if (!record.isLocked) {
                GoldButton(
                    text = stringResource(Res.string.daily_records_save_next),
                    onClick = { parsed?.let(onSave) },
                    enabled = parsed != null && !invalid,
                    modifier = Modifier.fillMaxWidth().handCursor()
                )
            }
        }
    }
}

/** Test tag of the month's table header row (as wide as the table's columns, also where it scrolls sideways). */
const val DAILY_TABLE_TAG = "daily_records_table"
/** SH-168: the phone's "Enter takings for …" button. */
const val DAILY_ENTRY_BUTTON_TAG = "daily_records_entry_button"
/** SH-168: the bar's "i" over the notes about the amounts. */
const val DAILY_NOTES_BUTTON_TAG = "daily_records_notes_button"
/** SH-168: the notes about the amounts, while they are open. */
const val DAILY_NOTES_TAG = "daily_records_notes"

/**
 * The month's table. SH-159: every column has a minimum width (its widest figure or its header's
 * longest word, measured) and a weight; the columns share all the width the table is given by
 * their weights, and the table scrolls sideways (at the minimums) only when those do not fit. The
 * hours and comments columns join where they fit too (SH-83: no figure is ever cut).
 */
@Composable
fun DailyRecordsTable(
    records: List<DailyRecord>,
    currency: String,
    onRecordClick: (DailyRecord) -> Unit,
    onEditTarget: (DailyRecord) -> Unit
) {
    val layout = rememberDailyTableLayout(records, currency)
    BoxWithConstraints(Modifier.fillMaxSize()) {
        val inner = (maxWidth - MonthTableCardPadding - TableRowPadding * 2).coerceAtLeast(0.dp)
        val details = layout.fitsWithDetails(inner)
        val specs = layout.specs(details)
        DailyRecordsMonthTable(
            records, currency,
            columns = layout.columns(details).zip(fitColumns(inner, specs)),
            scrollsSideways = specs.minWidth() > inner,
            onRecordClick = onRecordClick,
            onEditTarget = onEditTarget
        )
    }
}

/** SH-159: the narrowest the whole table (with its card's margins) can be without scrolling sideways. */
@Composable
internal fun rememberDailyTableMinWidth(records: List<DailyRecord>, currency: String): Dp =
    rememberDailyTableLayout(records, currency).specs(details = false).minWidth() + TableRowPadding * 2 + MonthTableCardPadding

/** The month table card's side margins ([MonthTableCard]: 16dp each side). */
private val MonthTableCardPadding = 32.dp

/** A row's own side padding, inside the card. */
private val TableRowPadding = 4.dp

/** A cell's side padding (6dp each side): its minimum is its widest text plus this. */
private val TableCellPadding = 12.dp

/** SH-159: a table column's minimum width and its share ([weight]) of the width left over. */
internal data class TableColumn(val min: Dp, val weight: Float = 0f)

/** The narrowest [TableColumn]s can be side by side. */
internal fun List<TableColumn>.minWidth(): Dp = fold(0.dp) { sum, column -> sum + column.min }

/**
 * SH-159: the columns' widths in [available] width: each its minimum plus a [TableColumn.weight]
 * share of what is left; the minimums alone when they do not fit (the table then scrolls sideways).
 */
internal fun fitColumns(available: Dp, columns: List<TableColumn>): List<Dp> {
    val extra = available - columns.minWidth()
    val totalWeight = columns.sumOf { it.weight.toDouble() }.toFloat()
    if (extra <= 0.dp || totalWeight <= 0f) return columns.map { it.min }
    return columns.map { it.min + extra * (it.weight / totalWeight) }
}

/** The daily table's columns in order: a [fixed] or measured width, a [weight], [detail]s only where they fit. */
internal enum class DailyColumn(val weight: Float, val fixed: Dp? = null, val detail: Boolean = false) {
    // First, so it is on screen before the table is scrolled sideways (and away from the middle
    // of the visible row, where a tap opens the day).
    TARGET(0f, fixed = 48.dp),
    DATE(0.8f),
    SALES_PLAN(1.2f), SALES_REAL(1.2f),
    COSTS_PLAN(1.2f), COSTS_REAL(1.2f),
    RESULT_PLAN(1.2f), RESULT_REAL(1.2f),
    HOURS_PLAN(0.8f, detail = true), HOURS_REAL(0.8f, detail = true),
    LABOUR_PLAN(1f), LABOUR_REAL(1f),
    // SH-191: SPMH beside the labour %: the actual always on screen (as SPMH always was), the
    // plan with the other details where they fit (every day card and day pane shows both).
    SPMH_PLAN(1f, detail = true), SPMH_REAL(1f),
    // Comments take most of a very wide window's spare width.
    COMMENTS(3f, fixed = 160.dp, detail = true),
    LOCK(0f, fixed = 40.dp)
}

/** SH-159: the measured minimum width of each [DailyColumn] of one month. */
internal class DailyTableLayout(private val minimums: Map<DailyColumn, Dp>) {
    fun columns(details: Boolean): List<DailyColumn> = DailyColumn.entries.filter { details || !it.detail }

    fun specs(details: Boolean): List<TableColumn> =
        columns(details).map { TableColumn(it.fixed ?: minimums[it] ?: MinFigureColumn, it.weight) }

    /** Whether the hours and comments columns fit beside the others in [available] width. */
    fun fitsWithDetails(available: Dp): Boolean = specs(details = true).minWidth() <= available
}

/** No column narrower than this (a dash, a short header). */
private val MinFigureColumn = 56.dp

/** The date column also holds the staffing chip and the "Closed" note under the day. */
private val MinDateColumn = 72.dp

/** A header wraps to at most this many lines. */
private const val HEADER_LINES = 3

/** Measures the month's figures as the table prints them (in bold, as the results are) and its headers' longest words. */
@Composable
private fun rememberDailyTableLayout(records: List<DailyRecord>, currency: String): DailyTableLayout {
    val measurer = rememberTextMeasurer()
    val figureStyle = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold)
    val headerStyle = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold)
    val density = LocalDensity.current
    val headers = DailyColumn.entries.map { dailyColumnHeader(it, records) }
    val days = records.map { record -> dayCellText(LocalDate.parse(record.date)) }
    // SH-191: "312 zł/h" as the cells print it.
    val spmhPlan = records.map { formatSpmhOrDash(it.spmhPlan, currency) }
    val spmhReal = records.map { formatSpmhOrDash(it.spmhActual, currency) }
    val resultDay = LocalResultDay.current
    val resultDays = remember(records, resultDay) { records.map(resultDay) }
    return remember(records, resultDays, currency, headers, days, spmhPlan, spmhReal, figureStyle, headerStyle, density) {
        fun widest(texts: List<String>, style: TextStyle): Dp {
            val px = texts.distinct().maxOfOrNull { measurer.measure(it, style, maxLines = 1, softWrap = false).size.width } ?: 0
            return with(density) { px.toDp() }
        }
        fun money(values: List<Double?>) = values.map { value -> value?.let { formatMoney(it, currency) } ?: "-" }
        val figures: Map<DailyColumn, List<String>> = mapOf(
            DailyColumn.DATE to days,
            DailyColumn.SALES_PLAN to money(records.map { it.revenue.planNetto }),
            DailyColumn.SALES_REAL to money(records.map { it.revenue.realNetto }),
            DailyColumn.COSTS_PLAN to money(records.map { it.plannedCosts() }),
            DailyColumn.COSTS_REAL to money(records.map { it.actualCosts() }),
            // SH-195: the daily results, each day its share of the recurring costs.
            DailyColumn.RESULT_PLAN to money(resultDays.map { it.resultPlan }),
            DailyColumn.RESULT_REAL to money(resultDays.map { it.resultReal }),
            DailyColumn.HOURS_PLAN to records.map { it.costs.plannedHours.format(1) },
            DailyColumn.HOURS_REAL to records.map { it.costs.actualHours.format(1) },
            DailyColumn.LABOUR_PLAN to records.map { formatPercentOrDash(it.labourPercentPlan) },
            DailyColumn.LABOUR_REAL to records.map { formatPercentOrDash(it.labourPercentReal) },
            DailyColumn.SPMH_PLAN to spmhPlan,
            DailyColumn.SPMH_REAL to spmhReal
        )
        // The narrowest a header can be in at most HEADER_LINES lines, wrapped by word.
        fun header(text: String): Dp {
            val words = text.split(' ').filter { it.isNotBlank() }
            if (words.isEmpty()) return 0.dp
            var width = with(density) { widest(words, headerStyle).roundToPx() }
            val full = measurer.measure(text, headerStyle, maxLines = 1, softWrap = false).size.width
            val step = with(density) { 4.dp.roundToPx() }
            while (width < full && measurer.measure(text, headerStyle, constraints = Constraints(maxWidth = width)).lineCount > HEADER_LINES) {
                width += step
            }
            return with(density) { minOf(width, full).toDp() }
        }
        DailyTableLayout(
            minimums = DailyColumn.entries.filter { it.fixed == null }.associateWith { column ->
                val content = maxOf(widest(figures[column].orEmpty(), figureStyle), header(headers[column.ordinal]))
                maxOf(content + TableCellPadding, if (column == DailyColumn.DATE) MinDateColumn else MinFigureColumn)
            }
        )
    }
}

private fun DailyRecord.plannedCosts(): Double = costs.plannedLabour + costs.otherCosts
private fun DailyRecord.actualCosts(): Double = costs.actualByContractType.values.sum() + costs.otherCosts

/** "10 (Sat)" */
@Composable
private fun dayCellText(date: LocalDate): String = "${date.day} (${dayShort(date.dayOfWeek)})"

@Composable
private fun dailyColumnHeader(column: DailyColumn, records: List<DailyRecord>): String = when (column) {
    // SH-168: the flags' column says what they change.
    DailyColumn.TARGET -> stringResource(Res.string.daily_records_target_header)
    DailyColumn.LOCK -> ""
    DailyColumn.DATE -> stringResource(Res.string.date)
    DailyColumn.SALES_PLAN -> stringResource(Res.string.daily_records_rev_plan)
    DailyColumn.SALES_REAL -> stringResource(Res.string.daily_records_rev_real)
    DailyColumn.COSTS_PLAN -> stringResource(Res.string.daily_records_costs_plan)
    DailyColumn.COSTS_REAL -> stringResource(Res.string.daily_records_costs_real)
    DailyColumn.RESULT_PLAN -> stringResource(Res.string.daily_records_result_plan)
    DailyColumn.RESULT_REAL -> stringResource(Res.string.daily_records_result_real)
    DailyColumn.HOURS_PLAN -> stringResource(Res.string.daily_records_hours_plan)
    DailyColumn.HOURS_REAL -> stringResource(Res.string.daily_records_hours_real)
    DailyColumn.LABOUR_PLAN -> stringResource(labourPlanLabelRes(records.labourBase()))
    DailyColumn.LABOUR_REAL -> stringResource(labourRealLabelRes(records.labourBase()))
    DailyColumn.SPMH_PLAN -> stringResource(Res.string.spmh_plan)
    DailyColumn.SPMH_REAL -> stringResource(Res.string.spmh_real)
    DailyColumn.COMMENTS -> stringResource(Res.string.daily_records_comments)
}

/** The table at its [columns]' widths; the header stays while the days scroll (SH-128). */
@Composable
private fun DailyRecordsMonthTable(
    records: List<DailyRecord>,
    currency: String,
    columns: List<Pair<DailyColumn, Dp>>,
    scrollsSideways: Boolean,
    onRecordClick: (DailyRecord) -> Unit,
    onEditTarget: (DailyRecord) -> Unit
) {
    val listState = rememberLazyListState()
    val canScroll by remember { derivedStateOf { listState.canScrollForward || listState.canScrollBackward } }
    // SH-168: a table within the card's bottom margin of fitting would flip for ever (the scrolling
    // card drops that margin, then it fits, then the hugging card has it again and it scrolls):
    // once the scrolling card shows it all, it settles as fitting.
    var settledFits by remember(records.size) { mutableStateOf(false) }
    var scrolled by remember(records.size) { mutableStateOf(false) }
    LaunchedEffect(canScroll) {
        if (canScroll) scrolled = true else if (scrolled) settledFits = true
    }
    val scrolls = canScroll && !settledFits
    val tableWidth = columns.fold(TableRowPadding * 2) { sum, (_, width) -> sum + width }
    val rowScroll = rememberScrollState()
    val sideways = if (scrollsSideways) Modifier.horizontalScroll(rowScroll) else Modifier

    MonthTableCard(scrolls) {
        // SH-208: scrollbars for the mouse under and beside the table (the desktop app and the web).
        Row {
        Column(Modifier.weight(1f, fill = false)) {
        Column(sideways.width(tableWidth).weight(1f, fill = false)) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .testTag(DAILY_TABLE_TAG)
                    .background(MaterialTheme.colorScheme.surfaceVariant)
                    .padding(horizontal = TableRowPadding, vertical = 8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                columns.forEach { (column, width) ->
                    TableCell(
                        dailyColumnHeader(column, records), width = width, isHeader = true,
                        textAlign = when (column) {
                            DailyColumn.DATE, DailyColumn.COMMENTS -> TextAlign.Start
                            DailyColumn.TARGET -> TextAlign.Center
                            else -> TextAlign.End
                        }
                    )
                }
            }
            LazyColumn(state = listState) {
                itemsIndexed(records, key = { _, record -> record.date }) { index, record ->
                    if (index > 0) HorizontalDivider(thickness = Dp.Hairline, color = TableDividerColor)
                    DailyRecordRow(
                        record, currency, columns,
                        onClick = { onRecordClick(record) },
                        onEditTarget = { onEditTarget(record) },
                        background = rowBackground(record.date, index)
                    )
                }
            }
        }
        if (scrollsSideways) RowHorizontalScrollbar(rowScroll, Modifier.fillMaxWidth())
        }
        ListVerticalScrollbar(listState, Modifier.fillMaxHeight())
        }
    }
}

@Composable
private fun DailyRecordRow(
    record: DailyRecord,
    currency: String,
    columns: List<Pair<DailyColumn, Dp>>,
    onClick: () -> Unit,
    onEditTarget: () -> Unit,
    /** SH-128: zebra striping, weekends and holidays tinted. */
    background: Color = Color.Transparent
) {
    fun money(value: Double) = formatMoney(value, currency)
    val hasActuals = record.revenue.realNetto != null
    val why = rememberDayWhy(record)
    val day = dayCellText(LocalDate.parse(record.date))
    // SH-195: the day's result counts its share of the month's recurring costs.
    val resultDay = LocalResultDay.current
    val result = remember(record, resultDay) { resultDay(record) }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(background)
            .handCursor()
            .clickable(onClick = onClick)
            .padding(horizontal = TableRowPadding, vertical = 12.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        columns.forEach { (column, width) ->
            when (column) {
                DailyColumn.TARGET -> Box(Modifier.width(width), contentAlignment = Alignment.Center) {
                    EditTargetButton(record, onEditTarget)
                }
                DailyColumn.DATE -> Column(Modifier.width(width).padding(horizontal = TableCellPadding / 2)) {
                    Text(day, style = MaterialTheme.typography.bodyMedium, maxLines = 1)
                    // SH-226: the day's weather under the date.
                    LocalDayWeather.current[record.date]?.let { WeatherBadge(it, iconSize = 14.dp) }
                    // SH-227: and its event or special day, cut to the column.
                    LocalDaySpecials.current[record.date]?.let { SpecialDayMarker(it, maxWidth = width - TableCellPadding) }
                    ClosedDayNote(record.date, short = true)
                    LocalStaffingHints.current[record.date]?.let { StaffingChip(it) }
                }
                DailyColumn.SALES_PLAN -> TableCell(money(record.revenue.planNetto), width, why = why.salesPlan, currency = currency)
                DailyColumn.SALES_REAL -> TableCell(
                    record.revenue.realNetto?.let(::money) ?: "-", width,
                    color = if (hasActuals) MaterialTheme.colorScheme.primary else Color.Gray,
                    why = why.takings, currency = currency
                )
                DailyColumn.COSTS_PLAN -> TableCell(money(record.plannedCosts()), width, why = why.costs(Side.PLAN), currency = currency)
                DailyColumn.COSTS_REAL -> TableCell(
                    if (hasActuals) money(record.actualCosts()) else "-", width,
                    why = why.costs(Side.ACTUAL), currency = currency
                )
                DailyColumn.RESULT_PLAN -> TableCell(
                    money(result.resultPlan), width, fontWeight = FontWeight.Bold,
                    why = why.result(Side.PLAN), currency = currency
                )
                DailyColumn.RESULT_REAL -> TableCell(
                    if (hasActuals) money(result.resultReal) else "-", width,
                    fontWeight = FontWeight.Bold,
                    color = if (result.resultReal >= 0) Color(0xFF4CAF50) else Color(0xFFF44336),
                    why = why.result(Side.ACTUAL), currency = currency
                )
                DailyColumn.HOURS_PLAN -> TableCell(record.costs.plannedHours.format(1), width)
                DailyColumn.HOURS_REAL -> TableCell(if (record.costs.actualHours > 0) record.costs.actualHours.format(1) else "-", width)
                DailyColumn.LABOUR_PLAN -> TableCell(
                    formatPercentOrDash(record.labourPercentPlan), width,
                    why = why.labourPercent(Side.PLAN), currency = currency
                )
                DailyColumn.LABOUR_REAL -> TableCell(
                    if (hasActuals) formatPercentOrDash(record.labourPercentReal) else "-", width,
                    why = why.labourPercent(Side.ACTUAL), currency = currency
                )
                DailyColumn.SPMH_PLAN -> TableCell(formatSpmhOrDash(record.spmhPlan, currency), width, why = why.spmh(Side.PLAN), currency = currency)
                DailyColumn.SPMH_REAL -> TableCell(formatSpmhOrDash(record.spmhActual, currency), width, why = why.spmh(Side.ACTUAL), currency = currency)
                DailyColumn.COMMENTS -> TableCell(
                    record.revenue.comments.orEmpty(), width,
                    color = MaterialTheme.colorScheme.onSurfaceVariant, textAlign = TextAlign.Start
                )
                DailyColumn.LOCK -> Box(Modifier.width(width), contentAlignment = Alignment.Center) {
                    Icon(
                        imageVector = if (record.isLocked) Icons.Default.Lock else Icons.Default.Edit,
                        contentDescription = null,
                        modifier = Modifier.size(16.dp),
                        tint = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
            }
        }
    }
}

/** A table cell [width] wide; figures are right-aligned as in a spreadsheet. */
@Composable
fun TableCell(
    text: String,
    width: Dp,
    isHeader: Boolean = false,
    color: Color = Color.Unspecified,
    fontWeight: FontWeight? = null,
    textAlign: TextAlign = TextAlign.End,
    /** SH-152: how the figure was calculated (tap to see). */
    why: (() -> Calculation?)? = null,
    currency: String = ""
) {
    // An explainable figure is only as wide as its text: the box aligns it in its column.
    val alignment = when (textAlign) {
        TextAlign.End, TextAlign.Right -> Alignment.CenterEnd
        TextAlign.Center -> Alignment.Center
        else -> Alignment.CenterStart
    }
    val explainable = why != null && text != "-"
    Box(Modifier.width(width).padding(horizontal = TableCellPadding / 2), contentAlignment = alignment) {
        ExplainableAmount(
            text = text,
            explain = why.takeIf { explainable },
            currency = currency,
            style = if (isHeader) MaterialTheme.typography.labelMedium else MaterialTheme.typography.bodyMedium,
            fontWeight = fontWeight ?: if (isHeader) FontWeight.Bold else FontWeight.Normal,
            color = color,
            textAlign = textAlign,
            // Headers wrap by word (a column is at least as wide as its header's longest word); a
            // figure always fits its column, the ellipsis is a last resort for a long comment.
            maxLines = if (isHeader) HEADER_LINES else 1,
            overflow = TextOverflow.Ellipsis,
            // Plain text fills the column (a wrapped header aligns each line); explainable text hugs its figure.
            modifier = if (explainable) Modifier else Modifier.fillMaxWidth()
        )
    }
}

@Composable
fun EditActualsDialog(
    record: DailyRecord,
    currency: String,
    onDismiss: () -> Unit,
    onSave: (netto: Double?, plan: Double?, comments: String?) -> Unit,
    /** SH-163: the typed figures saved and the day locked, after a confirmation. */
    onLock: (netto: Double?, plan: Double?, comments: String?) -> Unit,
    /** SH-163: a locked day opened again (null: not offered). */
    onUnlock: (() -> Unit)? = null,
    /** SH-54: the day's staffing hint, for those who may see money. */
    staffing: DayStaffingHint? = null,
    /**
     * SH-257: the day's hours in one line ("Godziny: 5 zmian, 2 do potwierdzenia →") opening Godziny
     * pracy on the day ([onOpenHours]); null: not shown.
     */
    hours: com.evoapps.evoshift.domain.model.WorkHoursDaySummary? = null,
    onOpenHours: (() -> Unit)? = null,
    /** SH-128: the day recalculated from the typed figures, until they are saved. */
    preview: DailyRecord? = null,
    onPreview: (netto: Double?, plan: Double?) -> Unit = { _, _ -> },
    onClearPreview: () -> Unit = {},
    /** SH-228: the day's sales target (the phone's rows have no flag of their own); null: not offered. */
    onEditTarget: (() -> Unit)? = null,
    /** SH-228: only to read (a role without money editing): no fields to change, Close only. */
    readOnly: Boolean = false
) {
    var planStr by remember { mutableStateOf(formatEditable(record.revenue.planNetto)) }
    var nettoStr by remember { mutableStateOf(record.revenue.realNetto?.let { formatEditable(it) } ?: "") }
    var comments by remember { mutableStateOf(record.revenue.comments ?: "") }
    var confirmLock by remember { mutableStateOf(false) }

    val locked = record.isLocked || readOnly
    val numberError = stringResource(Res.string.number_invalid)
    fun invalid(value: String) = value.isNotBlank() && parseDecimal(value) == null
    val valid = !invalid(planStr) && !invalid(nettoStr)
    // SH-128: the labour % follows the typed figures shortly after typing stops (or at once on
    // leaving a field or Done).
    val previewNow = rememberTypedPreview(record.date, nettoStr, planStr, enabled = !locked && valid, onClear = onClearPreview) {
        onPreview(parseDecimal(nettoStr), parseDecimal(planStr))
    }
    val save = { if (valid) onSave(parseDecimal(nettoStr), parseDecimal(planStr), comments.trim().ifBlank { null }) }
    // SH-163: the day's job is the till figure: the takings come first and get the focus.
    val takingsFocus = remember { FocusRequester() }

    EvoDialog(
        // SH-163: "Friday, 16 October", not the ISO date.
        title = dayAndDate(LocalDate.parse(record.date)),
        subtitle = if (record.isLocked) stringResource(Res.string.daily_records_locked) else null,
        icon = if (record.isLocked) Icons.Default.Lock else Icons.Default.PointOfSale,
        onDismiss = onDismiss,
        confirm = if (locked) null else DialogAction(stringResource(Res.string.save), save, enabled = valid),
        // SH-163: a locked day can be opened again; locking itself sits apart from Save, in the body.
        neutral = if (record.isLocked && !readOnly && onUnlock != null) DialogAction(stringResource(Res.string.daily_records_unlock), onUnlock, icon = Icons.Default.LockOpen) else null,
        dismiss = DialogAction(stringResource(if (locked) Res.string.close else Res.string.cancel), onDismiss)
    ) {
        // SH-228: what the phone's row only marks: the weather, the special days, a closed day, the target.
        DaySheetHeader(record, onEditTarget.takeIf { !locked })
        if (staffing != null) StaffingHintLines(staffing, currency, color = Color.White.copy(alpha = 0.8f), onDark = true)
        // SH-228: the owner's revenue for the day (the row shows the takings and the result).
        DayIncomeFigures(preview ?: record, isPreview = preview != null, currency = currency)
        // SH-128: the day's labour %, from the typed figures while they are not saved.
        DayLabourFigures(preview ?: record, isPreview = preview != null, currency = currency)
        // Inside the dialog's window, after the dialog took the focus for its keys (SH-98).
        LaunchedEffect(locked) { if (!locked) runCatching { takingsFocus.requestFocus() } }
        // Takings are always net (SH-70): there is no gross figure to enter.
        EvoTextField(
            value = nettoStr,
            onValueChange = { nettoStr = it },
            label = stringResource(Res.string.daily_records_actual_net),
            modifier = Modifier.focusRequester(takingsFocus).previewOnBlur(previewNow),
            keyboardType = KeyboardType.Decimal,
            // SH-163: the keyboard's Done saves the day.
            imeAction = ImeAction.Done,
            keyboardActions = KeyboardActions(onDone = { save() }),
            error = numberError.takeIf { invalid(nettoStr) },
            enabled = !locked,
            suffix = currency
        )
        EvoTextField(
            value = planStr,
            onValueChange = { planStr = it },
            label = stringResource(Res.string.daily_records_planned_net),
            modifier = Modifier.previewOnBlur(previewNow),
            keyboardType = KeyboardType.Decimal,
            imeAction = ImeAction.Done,
            keyboardActions = KeyboardActions(onDone = { save() }),
            error = numberError.takeIf { invalid(planStr) },
            enabled = !locked,
            suffix = currency
        )
        EvoTextField(
            value = comments,
            onValueChange = { comments = it },
            label = stringResource(Res.string.daily_records_comments),
            singleLine = false,
            minLines = 2,
            imeAction = ImeAction.Default,
            enabled = !locked
        )
        if (!locked) LockDayButton(enabled = valid, onClick = { confirmLock = true })
        if (hours != null && onOpenHours != null) DayHoursLine(hours, onOpenHours)
    }

    if (confirmLock) {
        LockDayConfirmDialog(
            date = record.date,
            takings = parseDecimal(nettoStr),
            currency = currency,
            onConfirm = {
                confirmLock = false
                onLock(parseDecimal(nettoStr), parseDecimal(planStr), comments.trim().ifBlank { null })
            },
            onDismiss = { confirmLock = false }
        )
    }
}

/**
 * SH-163: "Lock day" as a quiet text action under the day's fields, apart from Save, on the navy
 * dialog or pane. It only asks ([LockDayConfirmDialog]); nothing is locked by this tap.
 */
@Composable
internal fun LockDayButton(enabled: Boolean, onClick: () -> Unit, modifier: Modifier = Modifier) {
    TextButton(
        onClick = onClick,
        enabled = enabled,
        colors = ButtonDefaults.textButtonColors(contentColor = Color.White.copy(alpha = 0.85f)),
        modifier = modifier.handCursor()
    ) {
        Icon(Icons.Default.Lock, contentDescription = null, modifier = Modifier.size(18.dp))
        Spacer(Modifier.width(8.dp))
        Text(stringResource(Res.string.daily_records_lock))
    }
}

/**
 * SH-163: "Lock this day?" naming the day and its typed takings: confirming saves what was typed
 * and locks the day ("Save and lock day"); the day can be reopened later.
 */
@Composable
internal fun LockDayConfirmDialog(date: String, takings: Double?, currency: String, onConfirm: () -> Unit, onDismiss: () -> Unit) {
    EvoConfirmDialog(
        title = stringResource(Res.string.daily_records_lock_confirm_title),
        text = stringResource(
            Res.string.daily_records_lock_confirm_text,
            dayAndDate(LocalDate.parse(date)),
            takings?.let { formatMoney(it, currency) } ?: stringResource(Res.string.daily_records_lock_no_takings)
        ),
        confirmLabel = stringResource(Res.string.daily_records_save_and_lock),
        onConfirm = onConfirm,
        onDismiss = onDismiss,
        icon = Icons.Default.Lock
    )
}

/**
 * SH-228: the top of a day's sheet: its weather, its special days in words and a closed day's
 * reason, and the "Plan sprzedaży" chip that changes its target ([onEditTarget]; null: none).
 */
@Composable
internal fun DaySheetHeader(record: DailyRecord, onEditTarget: (() -> Unit)?) {
    val muted = Color.White.copy(alpha = 0.8f)
    val weather = LocalDayWeather.current[record.date]
    val specials = LocalDaySpecials.current[record.date]
    if (weather == null && specials == null && onEditTarget == null && record.date !in LocalDayClosures.current) return
    CompositionLocalProvider(LocalContentColor provides muted) {
        Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
            weather?.let { WeatherBadge(it, range = true, markForecast = true) }
            specials?.let { SpecialDaysLine(it) }
            ClosedDayNote(record.date, color = muted)
            onEditTarget?.let { EditTargetButton(record, it, tint = Color.White, labelled = true, onDark = true) }
        }
    }
}

/** SH-228: the day's income (commission and fixed revenue), plan | actual, on the navy sheet. */
@Composable
internal fun DayIncomeFigures(record: DailyRecord, isPreview: Boolean, currency: String) {
    val why = rememberDayWhy(record)
    val hasActuals = record.revenue.realNetto != null
    CardFigures(
        stringResource(Res.string.daily_records_income_plan) to formatMoney(record.incomePlan, currency),
        stringResource(Res.string.daily_records_income_real) to (if (hasActuals) formatMoney(record.incomeReal, currency) else "-"),
        firstWhy = why.income(Side.PLAN), secondWhy = why.income(Side.ACTUAL), currency = currency,
        labelColor = Color.White.copy(alpha = 0.7f), highlightColor = LightGold, preview = isPreview
    )
}

/**
 * SH-128: the day's labour % (plan and actual, and with a commission of the sales too) and SPMH (SH-191) on the navy
 * dialog or pane; a [isPreview] day (figures typed, not saved) in italics with a note saying so.
 */
@Composable
internal fun DayLabourFigures(record: DailyRecord, isPreview: Boolean, currency: String = "") {
    val muted = Color.White.copy(alpha = 0.7f)
    val why = rememberDayWhy(record)
    val hasActuals = record.revenue.realNetto != null
    Column {
        CardFigures(
            stringResource(labourPlanLabelRes(record.labourBase)) to formatPercentOrDash(record.labourPercentPlan),
            stringResource(labourRealLabelRes(record.labourBase)) to (if (hasActuals) formatPercentOrDash(record.labourPercentReal) else "-"),
            firstWhy = why.labourPercent(Side.PLAN), secondWhy = why.labourPercent(Side.ACTUAL), currency = currency,
            highlightSecond = hasActuals,
            labelColor = muted,
            highlightColor = LightGold,
            preview = isPreview
        )
        if (record.labourBase == LabourBase.INCOME) {
            CardFigures(
                stringResource(Res.string.daily_records_labor_plan) to formatPercentOrDash(record.labourPercentOfSalesPlan),
                stringResource(Res.string.daily_records_labor_real) to (if (hasActuals) formatPercentOrDash(record.labourPercentOfSalesReal) else "-"),
                firstWhy = why.labourPercentOfSales(Side.PLAN), secondWhy = why.labourPercentOfSales(Side.ACTUAL), currency = currency,
                labelColor = muted,
                highlightColor = LightGold,
                preview = isPreview
            )
        }
        // SH-191: SPMH next to the labour %.
        DaySpmhFigures(record, currency, labelColor = muted, highlightColor = LightGold, highlightSecond = true, preview = isPreview)
        // SH-195: the day's result and margin.
        DayResultFigures(record, currency, labelColor = muted, highlightColor = LightGold, onDark = true, preview = isPreview)
        if (isPreview) PreviewNote()
    }
}

/** SH-128: under figures recalculated from typed values: they are not saved yet. */
@Composable
internal fun PreviewNote(color: Color = Color.White.copy(alpha = 0.7f), visible: Boolean = true) {
    Text(
        stringResource(Res.string.daily_records_preview_note),
        style = MaterialTheme.typography.labelSmall,
        fontStyle = FontStyle.Italic,
        color = color,
        modifier = Modifier.padding(top = 4.dp).then(if (visible) Modifier else Modifier.alpha(0f).clearAndSetSemantics {})
    )
}

/** How long after the last keystroke the typed figures are recalculated (SH-128: 800–1000 ms). */
internal const val PREVIEW_DELAY_MILLIS = 900L

/**
 * SH-128: recalculates the typed figures [values] of [date] with [preview] [PREVIEW_DELAY_MILLIS]
 * after they last changed (while [enabled]); the returned function does it at once (leaving a
 * field, Done). Leaving the day drops its preview ([onClear]).
 */
@Composable
internal fun rememberTypedPreview(date: String, vararg values: String, enabled: Boolean, onClear: () -> Unit, preview: () -> Unit): () -> Unit {
    val latest by rememberUpdatedState(preview)
    val clear by rememberUpdatedState(onClear)
    val canPreview by rememberUpdatedState(enabled)
    LaunchedEffect(date, *values) {
        if (!canPreview) return@LaunchedEffect
        delay(PREVIEW_DELAY_MILLIS)
        latest()
    }
    DisposableEffect(date) { onDispose { clear() } }
    return remember { { if (canPreview) latest() } }
}

/** SH-128: recalculates at once when the field loses the focus (after having it). */
internal fun Modifier.previewOnBlur(previewNow: () -> Unit): Modifier = composed {
    var focused by remember { mutableStateOf(false) }
    onFocusChanged { state ->
        if (focused && !state.hasFocus) previewNow()
        focused = state.hasFocus
    }
}

/** "12 (Mon)": how a day is named in the table and on the day cards. */
@Composable
internal fun dayLabel(record: DailyRecord): String {
    val date = LocalDate.parse(record.date)
    return "${date.day} (${dayShort(date.dayOfWeek)})"
}

/**
 * SH-76: changes one day's planned revenue (target) once the month exists; hidden on a closed day.
 * Its description names the day, so each row's button can be told apart.
 */
@Composable
internal fun EditTargetButton(
    record: DailyRecord,
    onClick: () -> Unit,
    tint: Color = MaterialTheme.colorScheme.onSurfaceVariant,
    /** SH-168: a "Sales target" chip (a phone's day card) instead of the bare flag. */
    labelled: Boolean = false,
    /** SH-228: on the navy day sheet: a light chip. */
    onDark: Boolean = false
) {
    if (record.isLocked) return
    val description = stringResource(Res.string.daily_records_edit_target, dayLabel(record))
    if (labelled) {
        AssistChip(
            onClick = onClick,
            label = { Text(stringResource(Res.string.daily_records_target_chip), style = MaterialTheme.typography.labelMedium) },
            leadingIcon = { Icon(Icons.Default.Flag, contentDescription = null, modifier = Modifier.size(16.dp), tint = tint) },
            colors = if (onDark) AssistChipDefaults.assistChipColors(labelColor = Color.White, leadingIconContentColor = Color.White)
                else AssistChipDefaults.assistChipColors(),
            border = if (onDark) BorderStroke(1.dp, Color.White.copy(alpha = 0.5f)) else AssistChipDefaults.assistChipBorder(enabled = true),
            modifier = Modifier.handCursor().semantics { contentDescription = description }
        )
        return
    }
    // SH-163: a 48 dp target (the icon stays 18 dp).
    IconButtonWithTooltip(onClick = onClick, modifier = Modifier.minimumInteractiveComponentSize(), tooltip = description) {
        Icon(
            Icons.Default.Flag,
            contentDescription = description,
            modifier = Modifier.size(18.dp),
            tint = tint
        )
    }
}

/**
 * SH-76: one day's planned revenue (net). The planned labour % against the typed target shows
 * as it is typed; empty goes back to the weekday's sales target.
 */
@Composable
fun EditTargetDialog(
    record: DailyRecord,
    currency: String,
    onDismiss: () -> Unit,
    onSave: (Double?) -> Unit,
    /** SH-120: the day's suggested target from the sales history, if any. */
    suggestion: DaySuggestion? = null
) {
    var targetStr by remember { mutableStateOf(formatEditable(record.revenue.planNetto)) }
    val target = parseDecimal(targetStr)
    val invalid = targetStr.isNotBlank() && (target == null || target < 0)
    val plannedCost = record.laborStats.planned.totalCost

    EvoDialog(
        // SH-163: "Sales target", with "Friday, 16 October" under it.
        title = stringResource(Res.string.daily_records_target_title),
        subtitle = dayAndDate(LocalDate.parse(record.date)),
        icon = Icons.Default.Flag,
        onDismiss = onDismiss,
        confirm = DialogAction(
            stringResource(Res.string.save),
            { onSave(if (targetStr.isBlank()) null else target) },
            enabled = !invalid
        ),
        dismiss = DialogAction(stringResource(Res.string.cancel), onDismiss)
    ) {
        EvoTextField(
            value = targetStr,
            onValueChange = { targetStr = it },
            label = stringResource(Res.string.daily_records_planned_net),
            keyboardType = KeyboardType.Decimal,
            imeAction = ImeAction.Done,
            supportingText = stringResource(Res.string.daily_records_target_hint),
            error = stringResource(Res.string.number_invalid).takeIf { invalid },
            suffix = currency
        )
        if (target != null && target > 0 && !invalid) {
            Text(
                stringResource(Res.string.daily_records_planned_labor, formatPercent(plannedCost / target * 100)),
                // The dialog body is navy: inherit its white text (onSurfaceVariant is dark navy).
                style = MaterialTheme.typography.bodyMedium
            )
        }
        suggestion?.let { ForecastSuggestion(it, currency, onUse = { targetStr = formatEditable(it.amount) }) }
    }
}

private fun Double.format(digits: Int): String = formatDecimal(this, digits)

/**
 * SH-55: "Closed (non-trading Sunday)" under a day the workplace's Sunday policy closes; [short]
 * shows "Closed" where a table cell has no room, with the whole reason for screen readers.
 */
@Composable
internal fun ClosedDayNote(date: String, short: Boolean = false, color: Color = MaterialTheme.colorScheme.onSurfaceVariant) {
    val closure = LocalDayClosures.current[date] ?: return
    val label = closureLabel(closure)
    Text(
        if (short) stringResource(Res.string.day_closed) else label,
        style = MaterialTheme.typography.labelSmall,
        fontWeight = FontWeight.SemiBold,
        color = color,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        modifier = if (short) Modifier.semantics { contentDescription = label } else Modifier
    )
}

/** SH-128: weekends and public holidays by ISO date: their rows and day cards are tinted. */
internal val LocalRestDays = staticCompositionLocalOf<Set<String>> { emptySet() }

/** SH-128: a weekend's or a public holiday's row: a cool blue-grey, apart from the zebra and the chips. */
internal val RestDayTint: Color get() = com.evoapps.evoshift.ui.AppAppearance.palette.base.restTint

/** SH-128: every other row, a faint navy. */
private val ZebraTint: Color get() = DeepNavy.copy(alpha = 0.035f)

/** SH-128: the thin line between the table's rows. */
private val TableDividerColor: Color get() = DeepNavy.copy(alpha = 0.12f)

/** Test tag of the month's table card while the whole table fits (every corner rounded). */
const val DAILY_TABLE_FITS_TAG = "daily_records_table_fits"

/** Test tag of the month's table card while it scrolls (down to the bottom edge, top corners rounded). */
const val DAILY_TABLE_SCROLLS_TAG = "daily_records_table_scrolls"

/** SH-128: a row's background: weekends and holidays tinted, the other rows striped. */
@Composable
internal fun rowBackground(date: String, index: Int): Color = when {
    date in LocalRestDays.current -> RestDayTint
    index % 2 == 1 -> ZebraTint
    else -> Color.Transparent
}

/**
 * SH-128: the month's table in a card like the figures above it. When the whole table fits it
 * hugs it, every corner rounded; when it [scrolls] it runs to the bottom edge of the screen, only
 * its top corners rounded (the header row above the list stays in place).
 */
@Composable
internal fun MonthTableCard(scrolls: Boolean, content: @Composable () -> Unit) {
    val shape = if (scrolls) RoundedCornerShape(topStart = 16.dp, topEnd = 16.dp) else RoundedCornerShape(16.dp)
    Box(
        Modifier
            .padding(start = 16.dp, end = 16.dp, top = 8.dp, bottom = if (scrolls) 0.dp else 16.dp)
            .testTag(if (scrolls) DAILY_TABLE_SCROLLS_TAG else DAILY_TABLE_FITS_TAG)
            .shadow(4.dp, shape)
            .clip(shape)
            .background(LightMetallicBrush)
            .border(1.dp, DeepNavy.copy(alpha = 0.15f), shape)
    ) {
        content()
    }
}

/**
 * SH-247: the daily results before the month is read: the days' cards on phones, the table's
 * header and rows on wider windows, as placeholders.
 */
@Composable
private fun DailyRecordsPlaceholder(modifier: Modifier = Modifier) {
    val compact = com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass.current.isCompact
    com.evoapps.evoshift.widgets.SkeletonArea(modifier.fillMaxSize().padding(16.dp)) {
        if (compact) {
            Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                repeat(5) { com.evoapps.evoshift.widgets.SkeletonRowCard(leadingShape = androidx.compose.foundation.shape.RoundedCornerShape(8.dp), lines = 3) }
            }
        } else {
            com.evoapps.evoshift.widgets.RegularCard(Modifier.fillMaxWidth()) {
                Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                    com.evoapps.evoshift.widgets.SkeletonBlock(Modifier.fillMaxWidth().height(36.dp))
                    repeat(10) {
                        androidx.compose.foundation.layout.Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                            repeat(6) { column ->
                                com.evoapps.evoshift.widgets.SkeletonText(
                                    Modifier.weight(if (column == 0) 1.4f else 1f),
                                    widthFraction = if (column == 0) 0.8f else 0.6f
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}
